"use strict"

import React from "react"

import { isLTPM } from "../../../components/shared_components_registration"
const registration = {
  download_title: (intl) => (isLTPM ? intl.formatMessage({ id: "general.download" }) : "Download Data"),
}

export default class DataExportButton extends React.PureComponent {
  static defaultProps = {
    filename: "exported.csv",
  }

  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  componentWillUnmount() {
    if (this.blobURL) {
      URL.revokeObjectURL(this.blobURL)
    }
  }

  render() {
    return (
      <a
        href={"#"}
        download={this.props.filename}
        className={
          "link_btn_outline_primary btn" +
          (this.props.dataThunk && !this.props.disabled ? "" : " disabled") +
          (this.props.small ? " btn-sm" : "")
        }
        role={"button"}
        onClick={this.onClick}
        ref={(element) => (this.downloadAnchor = element)}
      >
        <span title={registration["download_title"](this.props.intl)} className="fa fa-download" />
      </a>
    )
  }

  onClick(ev) {
    if (this.blobURL) {
      URL.revokeObjectURL(this.blobURL)
    }

    try {
      const blob = new Blob([this.props.dataThunk()])
      this.blobURL = URL.createObjectURL(blob)
      this.downloadAnchor.href = this.blobURL
    } catch (err) {
      ev.preventDefault() // Abort download if an export hasn't been generated
      console.error(err)
      alert(err.toString())
    }
  }
}
